export default {
  created() {
    this.setPageTitle()
  },
  methods: {
    setPageTitle() {
      const {title} = this.$options
      if (title) {
        document.title = 'Campost Payment Admin - ' + (
          typeof title === 'function'
            ? title.call(this)
            : title
        )
      }
    }
  }
}
